module.exports = __webpack_public_path__ + "img/box.2b493cd4.png";